<template>
  <div>
    <v-toolbar :key="key" flat color="white">
      <h2 class="grey--text px-2 pt-3" v-if="packageInfo">Global Package Summary: {{packageInfo.name}}</h2>
    </v-toolbar>
    <v-divider></v-divider>

    <v-toolbar v-if="packageInfo&&activeServiceAccounts" :key="key" flat class="white py-3">
      <v-flex xs12 sm12 md12 min-width="1000px">
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-flex xs3 sm3 md3 lg3 my-4>
              <v-card flat color="white">
                <h3>Total Sales:</h3>
                <h3 class="green--text">{{totalRevenue|currency}}</h3>
              </v-card>
            </v-flex>
            <v-flex xs3 sm3 md3 lg3 my-4>
              <v-card flat color="white">
                <h3>Total Cost of Sales:</h3>
                <h3 class="red--text">{{totalCost|currency}}</h3>
              </v-card>
            </v-flex>
            <v-flex xs3 sm3 md3 lg3 my-4>
              <v-card flat color="white">
                <h3>Gross Profit:</h3>
                <h3 class="green--text">{{totalGP|currency}}</h3>
              </v-card>
            </v-flex>
            <v-flex xs3 sm3 md3 lg3 my-4>
              <v-card flat color="white">
                <h3>Total Packages Sold:</h3>
                <h3>{{totalPackagesSold}}</h3>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-toolbar>
     <v-card flat color="white">
      <v-container grid-list-xs>
        <v-layout wrap justify-center align-center>
         

          <v-flex xs12 sm6 md4 min-width="2000px">
            <barchart
              v-if="loaded&&networks.length>0"
              :chartdata="packagesChartData"
              :options="packagesChartOptions"
            ></barchart>
          </v-flex>
          <v-flex xs12 sm6 md6 lg4>
            <doughnutchart
              v-if="loaded&&activeServiceAccounts.length>0"
              :chartdata="revenueGraph"
              :options="revenueGraphOptions"
            ></doughnutchart>
          </v-flex>
        
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import Api from "@/services/Api";
import BarChart from "./BarChart.vue";
import DoughnutChart from "./DoughnutChart.vue";
export default {
  components: {
    barchart: BarChart,
     doughnutchart: DoughnutChart,
  },
  data() {
    return {
     loaded:false,
     packagesChartData: {},
     packagesChartOptions: {},
     revenueGraph: {},
     revenueGraphOptions: {},
     packagesFno:[],
     totalRevenue:0,
     totalCost:0,
     totalGP:0,
     totalPackagesSold:0,
     activeServiceAccounts:[],
     ispPackages: [],
     key:0
    };
  },
  watch: {
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.fetchPackage()
      
    },
    fetchPackage(){
      Api().get('/customer/packagesIsps/' + this.$route.params.packagesIspId).then(response=>{
        this.packageInfo = response.data[0]
        this.fetchIspPackageSold()
      })
    },
     fetchIspPackageSold(){
            this.totalRevenue=0
            this.totalCost=0
            this.totalGP=0
            this.totalPackagesSold=0
            this.ispPackages=[]
            Api()
            .get('/customer/serviceAccounts/active/byPackage/'+this.$route.params.packagesIspId)
            .then(async response=>{
            this.activeServiceAccounts=response.data.accounts
            this.networks = response.data.networks

            this.totalPackagesSold =  this.activeServiceAccounts.length
            this.totalRevenue = this.activeServiceAccounts.length* this.packageInfo.recurringPriceVatInc
            this.totalCost = this.activeServiceAccounts.length*this.packageInfo.packagesFno.packageBasePrice*(1+$VAT)
            this.totalGP = this.totalRevenue - this.totalCost
            this.loadGraphs()
            this.key++
            })
        },
        loadGraphs(){
    (this.packagesChartData = {
          labels: this.networks.map(x=>x.networkname),
          datasets: [
            {
              label: "Packages Sold",
              data: this.networks.map(x=>x.total),
              backgroundColor: [
                "rgba(255, 99, 132, 0.2)",
                "rgba(54, 162, 235, 0.2)",
                "rgba(255, 206, 86, 0.2)",
                "rgba(75, 192, 192, 0.2)",
                "rgba(153, 102, 255, 0.2)",
                "rgba(255, 159, 64, 0.2)"
              ],
              borderColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)"
              ],
              borderWidth: 1
            }
          ]
        }),
          (this.packagesChartOptions = {
            title: {
              display: true,
              text: "Packages Sold"
            },
            tooltip: {
              enabled: true
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true
                  }
                }
              ]
            }
          });
        let revenueGraphData = [];
        revenueGraphData.push(this.totalRevenue);
        revenueGraphData.push(this.totalCost);

        // Revenue vs Cost Graph
        this.revenueGraph = {
          labels: ["Sales", "Cost of Sales"],
          datasets: [
            {
              label: "Revenue vs Cost ",
              data: revenueGraphData,
              backgroundColor: [
                "rgba(38,231,147, 0.2)",
                "rgba(255, 99, 132, 0.2)"
              ],
              borderColor: ["rgba(38,231,147, 1)", "rgba(255, 99, 132, 1)"],
              borderWidth: 1
            }
          ]
        };
        this.revenueGraphOptions = {
          title: {
            display: true,
            text: "Financial Overview"
          }
        };
        this.loaded = true;
        },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    createPackageFromTemplate() {
      let ispLocationNetworkId = this.isplocationnetwork.find(
        x => x.packagesFnoId === this.item.id
      ).id;
      Api()
        .post("/customer/packagesIsps", {
          name: this.item.packagesIspTemplate.name,
          description: this.item.packagesIspTemplate.description,
          onceOffPriceVatInc: this.item.packagesIspTemplate.onceOffPrice,
          recurringPriceVatInc: this.item.packagesIspTemplate.recurringPrice,
          isPromotion: this.item.packagesIspTemplate.isPromo,
          promotionDescription: this.item.packagesIspTemplate.promoDescription,
          term: this.item.packagesIspTemplate.term,
          isCapped: this.item.packagesIspTemplate.isCapped,
          isShaped: this.item.packagesIspTemplate.isShaped,
          cappedAmountGb: this.item.packagesIspTemplate.cappedAmountGb,
          isFup: this.item.packagesIspTemplate.isFup,
          fupUrl: this.item.packagesIspTemplate.fupUrl,
          startDate: new Date(),
          endDate: null,
          packagesFnoId: this.item.id,
          ispLocationNetworkId: parseInt(ispLocationNetworkId),
          locationNetworkId: this.$route.params.locationNetworkId,
          isVerified: false,
          isRegistered: true,
          createdById: this.$store.state.user.id,
          lastModifiedById: this.$store.state.user.id,
          verifiedById: null,
          packagesIspTemplateId: this.item.packagesIspTemplate.id,
          customerOrganisationId: this.$store.state.currentOrg.org.id,
          hasSpecificTerms: this.item.packagesIspTemplate.hasSpecificTerms,
          specificTerms: this.item.packagesIspTemplate.specificTerms,
          isActive: true
        })
        .then(response => {
          this.$emit("refresh");
        });
    },
   
  }
};
</script>